import React, { createContext, useContext, useState, useEffect } from 'react';
import { useUser } from '@clerk/clerk-react';

interface AdminApprovalContextType {
  isApproved: boolean;
  pendingUsers: any[];
  approveUser: (userId: string) => Promise<void>;
  rejectUser: (userId: string) => Promise<void>;
}

const AdminApprovalContext = createContext<AdminApprovalContextType | undefined>(undefined);

export const AdminApprovalProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user } = useUser();
  const [isApproved, setIsApproved] = useState(false);
  const [pendingUsers, setPendingUsers] = useState<any[]>([]);

  useEffect(() => {
    // Check if the current user is approved
    const checkApproval = async () => {
      if (user) {
        // Automatically approve admin users
        if (user.publicMetadata?.role === 'admin') {
          setIsApproved(true);
          return;
        }

        // For regular users, check their approval status
        // TODO: Implement API call to check user approval status
        // For now, we'll auto-approve all users for testing
        setIsApproved(true);
      }
    };

    checkApproval();
  }, [user]);

  const approveUser = async (userId: string) => {
    // TODO: Implement API call to approve user
    setPendingUsers(prev => prev.filter(u => u.id !== userId));
  };

  const rejectUser = async (userId: string) => {
    // TODO: Implement API call to reject user
    setPendingUsers(prev => prev.filter(u => u.id !== userId));
  };

  return (
    <AdminApprovalContext.Provider value={{ isApproved, pendingUsers, approveUser, rejectUser }}>
      {children}
    </AdminApprovalContext.Provider>
  );
};

export const useAdminApproval = () => {
  const context = useContext(AdminApprovalContext);
  if (!context) {
    throw new Error('useAdminApproval must be used within an AdminApprovalProvider');
  }
  return context;
}; 